import { useAppDispatch, useAppSelector } from "hooks/hooks";
import React, { useState, useEffect, FC } from "react";
import { fetchRecentComments } from "redux/features/comment-location/comment-locationSlice";

interface TestimonialProps {
  title: string;
}
const TestimonialCards: FC<TestimonialProps> = ({ title }) => {
  const dispatch = useAppDispatch();
  const commentState = useAppSelector((state) => state.featureComment?.comments || []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalCards = commentState.length;

  const extendedComments = [...commentState, ...commentState, ...commentState];

  useEffect(() => {
    dispatch(fetchRecentComments());
  }, []);

  useEffect(() => {
    if (totalCards === 0) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (prevIndex >= totalCards * 2) {
          return totalCards;
        }
        return prevIndex + 1;
      });
    }, 5000);

    return () => clearInterval(timer);
  }, [totalCards]);

  const getTranslateX = () => {
    return `translateX(-${(currentIndex * 100) / 3}%)`;
  };

  return (
    <div className="px-4 mx-auto my-12">
      <h2 className="mb-[3.25rem] text-2xl font-semibold text-center">{title}</h2>
      <div className="relative overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: getTranslateX(),
            transition: currentIndex >= totalCards * 2 ? "none" : "transform 0.5s ease-in-out",
          }}
        >
          {extendedComments.map((testimonial: any, index) => (
            <div key={`${testimonial.id}-${index}`} className="min-w-full md:min-w-[33.33%] px-4 flex-shrink-0">
              <div className="w-full max-w-md p-6 transition-shadow duration-300 bg-white border border-gray-200 shadow-lg dark:bg-neutral-800 rounded-xl hover:shadow-xl">
                {/* Stars */}
                <div className="flex mb-4">
                  {[...Array(5)].map((_, starIndex) => (
                    <svg
                      key={starIndex}
                      className={`w-5 h-5 ${
                        starIndex < testimonial.like
                          ? "text-yellow-400 fill-current"
                          : "text-white  fill-current stroke-gray-300"
                      }`}
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3 .921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784 .57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81 .588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Description */}
                <p className="mb-4 text-sm text-gray-600 dark:text-white">"{testimonial.text}"</p>

                {/* Publisher */}
                <p className="font-semibold text-right text-gray-800 dark:text-white">
                  - {testimonial.Client?.lastName + " " + testimonial.Client?.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCards;
